import { render } from "./GroupFeature.vue?vue&type=template&id=e2b0b104&ts=true"
import script from "./GroupFeature.vue?vue&type=script&lang=ts"
export * from "./GroupFeature.vue?vue&type=script&lang=ts"

import "./GroupFeature.vue?vue&type=style&index=0&id=e2b0b104&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__